import { render, staticRenderFns } from "./SalaryConfig.vue?vue&type=template&id=22f3e419"
import script from "./SalaryConfig.vue?vue&type=script&lang=js"
export * from "./SalaryConfig.vue?vue&type=script&lang=js"
import style0 from "./SalaryConfig.vue?vue&type=style&index=0&id=22f3e419&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports